import { DefaultDecimalSeparator } from "./utility-helper";

export abstract class CardValidatorHelper {

  public static readonly UsPostalCodeRegx: RegExp = /(^\d{5}$)|(^\d{5}-\d{4}$)/;
  public static readonly CaPostalCodeRegx: RegExp = /^([ABCEGHJKLMNPRSTVXY]\d[ABCEGHJKLMNPRSTVWXYZ])\ {0,1}(\d[ABCEGHJKLMNPRSTVWXYZ]\d)$/;

  public static IsValidRequestedAmount(amount: string, balanceDue: any, decimalSeparator: string): boolean {

    if (CardValidatorHelper.IsZeroAmount(amount, decimalSeparator)) {
      return false;
    }

    if (Number(amount.replace(decimalSeparator, DefaultDecimalSeparator)) > Number(balanceDue.replace(decimalSeparator, DefaultDecimalSeparator))) {
      return false;
    }

    if (amount.length > 10) {
      return false;
    }

    return true;
  }

  public static IsZeroAmount(amount: string, decimalSeparator: string = '.'): boolean {
    // starts with zero or more
    let regexPartOne = '^0+(\\';

    let regexPartTwo = decimalSeparator;

    // optional with decimal separator starts one zero or more
    let regexPartThree = '0{1,})?$'

    let regex = new RegExp(regexPartOne + regexPartTwo + regexPartThree, 'g');

    return regex.test(amount);
  }

  public static IsPostiveDecimalAmount(amount: string, decimalSeparator: string = '.'): boolean {
    // start with one digits or more
    let regexPartOne = '^(\\d+(\\';

    let regexPartTwo = decimalSeparator;

    // optional with decimal separator starts one digits or two 
    let regexPartThree = '[0-9]{1,2})?)$'

    let regex = new RegExp(regexPartOne + regexPartTwo + regexPartThree, 'g');

    return regex.test(amount);
  }
}
